import Loadable from 'react-loadable';
import React from 'react';
import DefaultLayout from '../views/layouts/default';


function loading(){
  return (<div>Please wait a moment</div>)
}
const Landing = Loadable({
  loader: () => import('../views/general/home'),
	loading: loading,
});

const PublicRoutes = [
	{
		url: '/',
		component: Landing,
		exact: true,
		public: true,
		layout: DefaultLayout
	}
];
const PrivateRoutes = [

];
export default PublicRoutes;
export { PublicRoutes, PrivateRoutes};


// WEBPACK FOOTER //
// ./src/app/routes/index.js